// @ts-nocheck

import { LOADING_STATUS } from '../../support/constants';
import { reducerWrapper } from '../../support/utils';

import { ESP_DOMAIN_VALIDATION } from '../../actions/EmailOnboarding/ESPDomainValidation';

var INIT_STATE = {
  loading: false,
  loadingStatus: LOADING_STATUS.INIT,
  error: null,
};

function Handler(state, action) {
  switch (action.type) {
    case ESP_DOMAIN_VALIDATION.response:
      return Object.assign({}, state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADED,
        error: null,
        ...action.data,
      });

    default:
      return state;
  }
}

const ESPDomainValidation = reducerWrapper(INIT_STATE, Handler, {
  request: [ESP_DOMAIN_VALIDATION],
  error: [ESP_DOMAIN_VALIDATION],
  resetOn: ['APP_CHANGE'],
});

export default ESPDomainValidation;
